// extracted by css-extract-rspack-plugin
var _1 = "FaWxe8_X_1Q7I_gd";
var _2 = "FaWxe8_X_1Q7I_gd";
export { _1 as "moments-identifier", _2 as "momentsIdentifier" }
